module.exports = __webpack_public_path__ + "img/avatar-3.5692bf51.png";